import { Grid } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import clsx from 'clsx';
import { PATHS } from 'constants/paths';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { generatePath } from 'react-router-dom';

import styles from '../../Sidebar.module.scss';

type Props = {
  well: any;
  tightWellAccessible?: boolean;
  wellboreId?: string;
};

const SidebarHomeRoute = ({ well, tightWellAccessible, wellboreId }: Props) => {
  const intl = useIntl();

  return (
    <NavLink
      exact
      to={wellboreId ? generatePath(PATHS.WELL_HOME, { wellboreId }) : PATHS.HOME}
      activeClassName={styles.activeLink}
      className={clsx(
        styles.link,
        styles.routesLink,
        well && well.tightWell && !tightWellAccessible && styles.disableLink,
      )}
      data-testid="sidebar-well-home-link"
    >
      <Grid container alignItems="center" className={styles.linkTitle}>
        <HomeIcon className={styles.linkIcon} />
        {intl.formatMessage({ id: 'sidebar.routes.wellHome' })}
      </Grid>
    </NavLink>
  );
};

export default SidebarHomeRoute;
